import { Injectable } from '@angular/core';
import { delay, Observable, of } from 'rxjs';

import type { IncidentTransactionsClient } from '../../../../../core/tokens/incident-transactions-client.token';
import type { IncidentTransactionsResponse } from '../models/incident-transactions-response.model';

@Injectable({ providedIn: 'root' })
export class IncidentTransactionsMockService implements IncidentTransactionsClient {
  getTransactions(
    _incidentNumber: string,
    _organizationId: string,
  ): Observable<IncidentTransactionsResponse> {
    const testVideoUrl = '/videos/video-test.mp4';
    const testThumbnailUrl = '/thumbnail-template.png';
    const response: IncidentTransactionsResponse = {
      transactions: [
        {
          medAmt: -100,
          uom: 'mcg',
          transactionType: 'Remove',
          date: '2025-01-01',
          time: '06:25:08',
          employeeName: 'Anthony M ',
          employeeId: 'AMY76',
          jobRole: 'Nurse',
          clinicalUnit: 'H-Green',
          video: testVideoUrl,
          thumbnail: testThumbnailUrl,
          aiFlag: '',
          rxIntrcpt: '',
        },
        {
          medAmt: 50,
          uom: 'mcg',
          transactionType: 'Integrated waste',
          date: '2025-01-01',
          time: '06:26:08',
          employeeName: 'Chuck H',
          employeeId: 'CHU85',
          jobRole: 'Nurse',
          clinicalUnit: 'H-Green',
          video: testVideoUrl,
          thumbnail: testThumbnailUrl,
          aiFlag: '',
          rxIntrcpt: '',
        },
      ],
      varAmount: 50,
    } satisfies IncidentTransactionsResponse;

    return of(response).pipe(delay(250));
  }
}
